import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CompanyInitialState } from './company.types'

const initialState: CompanyInitialState = {
  tabIndex: 0,
  mobileTabIndex: undefined,
}

export const companyslice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setTabIndex: (state, action: PayloadAction<{ index: number }>) => {
      state.tabIndex = action.payload.index
    },
    setMobileTabIndex: (state, action: PayloadAction<{ index: number }>) => {
      state.mobileTabIndex = action.payload.index
    },
    clearMobileTabIndex: (state) => {
      state.mobileTabIndex = undefined
    },
  },
})

export const { setTabIndex, setMobileTabIndex, clearMobileTabIndex } =
  companyslice.actions

export default companyslice.reducer
